import type { StateCriteria } from './stateCriteria';

export function formatOverall(score: string): string {
  const numeric = score.match(/^\d+(\.\d+)?$/);
  if (!numeric) return score;
  const n = score.includes('.') ? score : `${score}.0`;
  return `${n} composite`;
}

export function formatDomain(domain: string): string {
  const minimumMatch = domain.match(/^Minimum\s+(\d+(?:\.\d+)?)\s+in\s+(.+?)(?:\s+domain)?$/i);
  if (minimumMatch && minimumMatch[1] && minimumMatch[2]) {
    return `${minimumMatch[1]} ${minimumMatch[2].toLowerCase()}`;
  }
  return domain;
}

export function parseDomainStat(domain?: string): { value: string; label: string } | null {
  if (!domain) return null;
  const match = domain.match(/^Minimum\s+(\d+(?:\.\d+)?)\s+in\s+(.+?)(?:\s+domain)?$/i);
  if (!match || !match[1] || !match[2]) return null;
  const label = match[2];
  if (/[(),]/.test(label)) return null;
  return { value: match[1], label };
}

export function buildSummary(criteria: StateCriteria): string {
  if (criteria.summary) return criteria.summary;
  const parts = [formatOverall(criteria.overallScore)];
  if (criteria.domainSpecific) parts.push(formatDomain(criteria.domainSpecific));
  return parts.join(' • ');
}
